import { Injectable } from '@angular/core';
import {
  SwUpdate,
  VersionEvent,
  VersionReadyEvent
} from '@angular/service-worker';
import { EMPTY, interval, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

const MS_PER_MIN = 60 * 1000;
const MINS = 1 /* hours */ * 60;

@Injectable({ providedIn: 'root' })
export class SwUpdateService {
  private useServiceWorker: boolean;
  constructor(private updates: SwUpdate) {
    this.useServiceWorker = false; // isFeatureEnabled('useServiceWorker');

    if (!this.useServiceWorker) {
      console.log('Service Worker not enabled');
      return;
    }

    interval(MINS * MS_PER_MIN).subscribe(() => {
      console.log('Checking for app new version...');
      updates.checkForUpdate().then(available => {
        if (available) {
          console.log('New app version available');
        }
      });
    });
  }

  public start(): Observable<VersionEvent> {
    if (!this.useServiceWorker) {
      return EMPTY;
    }
    return this.updates.versionUpdates.pipe(
      filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
    );
  }
}
